import React, { useImperativeHandle, forwardRef, useRef } from "react";
import { View, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import SingleDatePicker from "@components/SingleDatePicker";
import { colors } from "@constants/theme";

interface ColumnDatePickerProps {
  dates: {
    fromDate?: string;
    toDate?: string;
  };
  handleDateChanged: (type: { type: string }, date: Date) => void;
}

export interface ColumnDatePickerRef {
  getDates: () => [Date, Date];
}

const ColumnDatePicker = forwardRef<ColumnDatePickerRef, ColumnDatePickerProps>(
  (props, ref) => {
    const fromDateRef = useRef<any>();
    const toDateRef = useRef<any>();

    const {
      dates: {
        toDate = new Date().toISOString(),
        fromDate = new Date().toISOString(),
      },
      handleDateChanged = () => {},
    } = props;

    const fromDateObj = fromDate ? new Date(fromDate) : new Date();
    const toDateObj = toDate ? new Date(toDate) : new Date();

    useImperativeHandle(ref, () => ({
      getDates: () => {
        return [fromDateRef.current.getDate(), toDateRef.current.getDate()];
      },
    }));

    return (
      <View style={styles.container}>
        <View style={styles.datePickerContainer}>
          <Text variant="body_text_3" style={styles.label}>
            Start Date
          </Text>
          <SingleDatePicker
            width="100%"
            datePlaceholder="Select Date"
            titleColor={colors.mediumBlack}
            ref={fromDateRef}
            date={fromDateObj}
            maximumDate={new Date()}
            handleDateChanged={function () {
              handleDateChanged.apply(null, [
                { type: "fromDate" },
                ...arguments,
              ]);
            }}
          />
        </View>

        <View style={styles.datePickerContainer}>
          <Text variant="body_text_3" style={styles.label}>
            End Date
          </Text>
          <SingleDatePicker
            width="100%"
            datePlaceholder="Select Date"
            titleColor={colors.mediumBlack}
            ref={toDateRef}
            date={toDateObj}
            minimumDate={fromDateObj}
            handleDateChanged={function () {
              handleDateChanged.apply(null, [{ type: "toDate" }, ...arguments]);
            }}
          />
        </View>
      </View>
    );
  },
);

const styles = StyleSheet.create({
  container: {
    width: "100%",
    paddingHorizontal: 16,
  },
  datePickerContainer: {
    marginBottom: 16,
  },
  label: {
    marginBottom: 8,
    color: colors.mediumBlack,
  },
});

export default ColumnDatePicker;
